<script>
/* eslint-disable */
import { mapGetters } from "vuex"
import ModalFooter from './ModalFooter.vue'
import ModalHeader from './ModalHeader.vue'
import ModalHeaderToolbar from './ModalHeaderToolbar.vue'
import CircuitList from './CircuitList.vue'
import EmptyScriptList from './EmptyScriptList.vue'
import DynamicCircuit from './DynamicCircuit.vue'
import AutoCueList from './AutoCueList.vue'

export default {
  components: {
    CircuitList,
    EmptyScriptList,
    ModalFooter,
    ModalHeader,
    ModalHeaderToolbar,
    DynamicCircuit,
    AutoCueList
  },
  computed: {
    ...mapGetters({
      scriptOpened: "scripts/scriptOpened",
      hasCircuits: "scripts/hasCircuits",
      circuits: "scripts/circuits",
      autoCue: "scripts/autoCue",
      renderList: "scripts/renderList"
    }),
    title() {
      return this.currentActivity.working_title
    },
    show: {
      set(value) {
        this.$store.commit("scripts/setOpened", value);
      },
      get() {
        return this.scriptOpened
      },
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow") {
          return "stretchflows";
        }else if (
          url == "update-workout" ||
          this.$route.path == "/create-workout") {
          return "workouts";
        }
      }
      return "commons";
    },
  },
  method: {
    close(){
      this.show = false
    },    
  }
}
</script>

<style scoped>
  .move-list{
    height: 65vh;
    overflow-y: scroll;
  }
  .modal-header{
    background-color: red;
    
  }
  .finish{
    font-weight: bold;
    font-family: 'Times New Roman', Times, serif;
    font-size: 1.5rem;
    color: #000;
    margin-left: -10px;
  }
 
</style>

<template>
    <b-modal
      v-model="show"
      size="xl"
      :title="title"
      id="script-modal-builder"
      scrollable
    >
      <template #modal-header="{ close }">
        <div class="w-100">
          <modal-header :title="title" :close="close"></modal-header>
          <modal-header-toolbar></modal-header-toolbar>
        </div>
      </template>
      <empty-script-list v-if="!hasCircuits"></empty-script-list>
      <div v-if="autoCue && renderList">
        <dynamic-circuit v-for="circuit in circuits" :circuit="circuit" :key="circuit.id"></dynamic-circuit>
      </div>
      <div v-if="!autoCue">
        <auto-cue-list></auto-cue-list>
      </div>
      <div class="row">
        <div class="col-md-11 offset-md-1"><div class="finish">FINISH</div></div>
      </div>
      <template #modal-footer>
        <modal-footer></modal-footer>
      </template>
    </b-modal>
</template>